import { logout as logoutAction } from '../actions/logout';
import { authTokenManager } from '../services/AuthTokenManager';
import { redirectToLogout } from '../services/pageRedirect';

export const logout = () => dispatch => {
    dispatch(logoutAction());
    authTokenManager.clear();
    redirectToLogout();
};
